import { useSWRConfig } from "swr";

export function useSWRFetcher() {
  const { fetcher } = useSWRConfig();

  return fetcher as <JSON = unknown>(input: RequestInfo, init?: RequestInit) => Promise<JSON>;
}
